module.exports = {
      id: "icon-X-usage",
      viewBox: "0 0 512.001 512.001",
      url: "/img/" + "063d56c0a9dcab4c3026b31719d540d0.svg#icon-X",
      toString: function () {
        return this.url;
      }
    }